import SharedDialog from '../../../../../../global/Modal/Modal';
import { SaveSearchModalProps } from '../types';

export function SaveSearchModal({
  isOpen,
  onClose,
  onConfirm,
  searchName,
  setSearchName,
  searchDataToSave,
  isSaving,
}: SaveSearchModalProps) {
  const activeFilters = searchDataToSave?.columnFilters?.filter(f => f.value && f.value.length !== 0) || [];

  return (
    <SharedDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Save Search"
      description="Review and customize your search before saving it to favorites."
      confirmText={isSaving ? 'Saving...' : 'Save Search'}
      cancelText="Cancel"
      onConfirm={onConfirm}
      data-testid="save-search-modal"
      hasConfirmBtn
    >
      <div className="mt-4">
        <div className="mb-3">
          <label htmlFor="searchName" className="form-label font-medium">
            Search Name:
          </label>
          <input
            id="searchName"
            type="text"
            className="form-control"
            value={searchName}
            onChange={e => setSearchName(e.target.value)}
            placeholder="Enter a name for this search"
            maxLength={100}
            disabled={isSaving}
          />
          {!searchName.trim() && <small className="text-danger">Please enter a name for the search</small>}
        </div>

        {searchDataToSave && (
          <div className="mt-3">
            <h6 className="font-medium mb-2">Search Details:</h6>
            <div className="bg-light p-3 rounded">
              <div className="row">
                <div className="col-md-6">
                  <small className="text-muted">View:</small> <strong>{searchDataToSave.view}</strong>
                  <br />
                  <small className="text-muted">Tab:</small> <strong>{searchDataToSave.tab}</strong>
                  <br />
                  <small className="text-muted">Source:</small> <strong>{searchDataToSave.source}</strong>
                  <br />
                  <small className="text-muted">Type:</small>{' '}
                  <strong>{searchDataToSave.isEvidence ? 'Evidence' : 'Summary'}</strong>
                </div>
                <div className="col-md-6">
                  <small className="text-muted">Search Items:</small>
                  <br />
                  {searchDataToSave.searchItems.length > 0 ? (
                    <small>{searchDataToSave.searchItems.map(item => item.name || item.id).join(', ')}</small>
                  ) : (
                    <small className="text-muted">No specific items</small>
                  )}
                </div>
              </div>

              <div className="mt-2">
                <small className="text-muted">Applied Column Filters:</small>
                <br />
                {activeFilters.length > 0 ? (
                  <small>
                    {activeFilters
                      .map(
                        f => `${f.label || f.name}: ${Array.isArray(f.value) ? f.value.join(', ') : f.value}`,
                      )
                      .join(', ')}
                  </small>
                ) : (
                  <small className="text-muted">No column filters applied</small>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </SharedDialog>
  );
}
